import * as constantes from "../constants/constantes.js";
//const ENDPOINT = "https://inleraningapi.azurewebsites.net";
const ENDPOINT = constantes.URLAPI;
const ENDPOINTTEST = constantes.URL__USUARIOTEST;
export default async function login ({userName,password}) {
    return await fetch(`${ENDPOINT}/Usuario/Login`,{
    //return await fetch(`${ENDPOINTTEST}/Login`,{
        method: "POST",
        //mode: "no-cors",
        headers:{
            //'Content-Type':'application/json'
            'Content-Type': 'application/json'
        },
        //headers: new Headers({ 'Content-Type': 'application/json' }),
        
        body:JSON.stringify({userName, password})
    }).then(res=>{
        if(!res.ok) throw new Error("Response is Not Ok")
        return res.json()
    }).then(res=>{
        if(res.errors) throw new Error(res.errors[0])
       
        return res
    })
}
